<script lang="ts">
import type { HTMLAttributes } from 'vue'
import type { ButtonVariants } from '#ui-kit/ui/button'

export interface InputGroupButtonProps {
  variant?: ButtonVariants['variant']
  iconOnly?: boolean
  loading?: boolean
  class?: HTMLAttributes['class']
  disabled?: boolean
}
</script>

<script setup lang="ts">
import type { InputGroupSize } from './InputGroup.vue'
import { computed, inject } from 'vue'
import { cn } from '#ui-kit/lib/utils'
import { Button } from '#ui-kit/ui/button'
import { INPUT_GROUP_KEY } from './InputGroup.vue'

const props = withDefaults(defineProps<InputGroupButtonProps>(), {
  variant: 'ghost',
  iconOnly: true,
})

const group = inject(INPUT_GROUP_KEY, null)

const buttonSizes: Record<InputGroupSize, ButtonVariants['size']> = {
  xs: 'xs',
  sm: 'xs',
  md: 'sm',
  lg: 'md',
  xl: 'md',
}

const size = computed(() => buttonSizes[group?.size.value ?? 'md'])
const isDisabled = computed(() => props.disabled || group?.disabled.value || false)
</script>

<template>
  <Button
    :variant="variant"
    :icon-only="iconOnly"
    :loading="loading"
    type="button"
    :size="size"
    :disabled="isDisabled"
    :class="cn('h-full shrink-0 rounded-none focus-visible:ring-inset focus-visible:ring-offset-0', props.class)"
  >
    <slot />
  </Button>
</template>
